
!function($)
{
    'use strict';
    
    var debug = false;
    function log(msg)
    {
        if (debug)
        {
            console.log('DatepickerExt: ' + msg + '.');
        }
    }
    
    function DatepickerExt(anchor, options)
    {
        this.$anchor = $(anchor);
        
        this.dateUnits = 
        {
            quarterYear: 5,
            month: 10,
            calendarWeek: 15
        };
        
        if (!debug)
        {
            this.$anchor.hide();
        }
        
        this.options = this.getOptions(options);
        
        this.view = this.options.view;
        
        this.buildContainer();
        
        this.buildReplaceButton();
        
        this.refreshReplaceButton();
      
        this.buildDropdownContainer();
        
        this.updateContent();
        
        this.registerEventHandler();
    }

    DatepickerExt.prototype =
    {
        defaults:
        {
        	view: null
        },
                
        datepickerDefaults:
        {
            month:
            {
                language: 'de',
                startView: 1,
                minViewMode: 1
            },
                    
            calendarWeek:
            {
                language: 'de',
                calendarWeeks: true,
                daysOfWeekDisabled: "0,1,2,3,4,5,6"
            }
        },

        constructor: DatepickerExt,

        getOptions: function(options)
        {
            return $.extend({}, this.defaults, options);
        },
        
        /**
         * Erzeugt den btn-group-Container. Benötigt als Wrapper, und um die Bootstrap-
         * Funktionalität "dropdown" benutzen zu können
         * 
         * @returns {void}
         */
        buildContainer: function()
        {
            this.$container = $('<div class="btn-group dp-ext-container" style="width:100%;"></div>');
            
            this.$anchor.after(this.$container);
        },

        buildReplaceButton: function()
        {
            this.$replaceButton = $('<button class="dropdown-toggle dp-ext-replace-button btn" data-toggle="dropdown">uneingeschränkt <span class="caret"></span></button>');
            
            this.$container.append(this.$replaceButton);
        },

        refreshReplaceButton: function()
        {
            var msg = '';
            switch (this.view.get('dateUnit'))
            {
                case this.dateUnits.quarterYear:
                    if (this.view.get('dateFrom') !== '')
                    {
                        msg += 'von ' + this.view.get('dateFrom').replace('.', '.Q ');
                    }
                    
                    if (msg !== '')
                    {
                        msg += ' ';
                    }
                    
                    if (this.view.get('dateTo') !== '')
                    {
                        msg += 'bis ' + this.view.get('dateTo').replace('.', '.Q ');
                    }
                    if (msg === '')
                    {
                        msg = 'Quartal';
                    }
                    break;
                    
                case this.dateUnits.month:
                    if (this.view.get('dateFrom') !== '')
                    {
                        msg += 'von ' + this.view.get('dateFrom');
                    }
                    
                    if (msg !== '')
                    {
                        msg += ' ';
                    }
                    
                    if (this.view.get('dateTo') !== '')
                    {
                        msg += 'bis ' + this.view.get('dateTo');
                    }
                    if (msg === '')
                    {
                        msg = 'Monat';
                    }
                    break;
                    
                case this.dateUnits.calendarWeek:
                    if (this.view.get('dateFrom') !== '')
                    {
                        msg += 'von ' + this.view.get('dateFrom').replace('.', '.KW ');
                    }
                    
                    if (msg !== '')
                    {
                        msg += ' ';
                    }
                    
                    if (this.view.get('dateTo') !== '')
                    {
                        msg += 'bis ' + this.view.get('dateTo').replace('.', '.KW ');
                    }
                    if (msg === '')
                    {
                        msg = 'Kalenderwoche';
                    }
                    break;
            }
            
            if (msg === '')
            {
                msg = 'uneingeschränkt';
            }
            
            this.$replaceButton.html(msg + ' <span class="caret"></span>');
        },

        buildDropdownContainer: function()
        {
            this.$dropdownContainer = $(
            '<div class="dropdown-menu dp-ext-popover">' + 
                '<div class="row">' +
                    '<ul class="nav nav-pills dp-ext-select-unit">' +
                    	'<li id="w-dp" class="dp" value="15"><a class="dp-ext-calendar-week" href="#">Kalenderwoche</a></li>' +
                    	'<li id="q-dp" class="dp" value="5"><a class="dp-ext-quarter-year" href="#">Quartal</a></li>' +
                        '<li id="m-dp" class="dp" value="10"><a class="dp-ext-month" href="#">Monat</a></li>' +
                        '<li style="float: right;"><a class="dp-ext-reset" href="#"><small>uneingeschränkt</small></a></li>' +
                    '</ul>' +
                '</div>' +
                '<div class="row dp-row hide">' +
                    '<div class="col-md-6"><h5>Von</h5></div>' +
                    '<div class="col-md-6"><h5>Bis</h5></div>' +
                '</div>' +
                '<div class="row dp-ext-row dp-ext-row-calendar-week">' +
	                '<div class="col-md-6 dp-ext-from"></div>' +
	                '<div class="col-md-6 dp-ext-to"></div>' +
	            '</div>' +
                '<div class="row dp-ext-row dp-ext-row-quarter-year">' +
                    '<div class="col-md-6 dp-ext-from"></div>' +
                    '<div class="col-md-6 dp-ext-to"></div>' +
                '</div>' +
                '<div class="row dp-ext-row dp-ext-row-month">' +
                    '<div class="col-md-6 dp-ext-from"></div>' +
                    '<div class="col-md-6 dp-ext-to"></div>' +
                '</div>' +
            '</div>');
    
            this.quarterYearPickers = this.$dropdownContainer.find('.dp-ext-row-quarter-year');
            this.monthPickers = this.$dropdownContainer.find('.dp-ext-row-month');
            this.calendarWeekPickers = this.$dropdownContainer.find('.dp-ext-row-calendar-week');
    
            this.quarterYearPickers.find('.dp-ext-from')
                .quarterYearPicker()
                .on('quarterYearChanged', $.proxy(function(e)
                {
                    this.view.set('dateFrom', e.date);
                    this.refreshReplaceButton();
                },this));
                
            this.quarterYearPickers.find('.dp-ext-to')
                .quarterYearPicker()
                .on('quarterYearChanged', $.proxy(function(e)
                {
                    this.view.set('dateTo', e.date);
                    this.refreshReplaceButton();
                },this));
                        
            this.monthPickers.find('.dp-ext-from')
                .datepicker(this.datepickerDefaults.month)
                .on('changeMonth changeYear', $.proxy(function(e)
                {
                    var date = new Date(e.date);
                    
                    this.view.set('dateFrom', (date.getMonth() + 1) + '.' + date.getFullYear());
                    var oldDate = this.monthPickers.find('.dp-ext-to').datepicker('getDate');
                    date.setMonth(date.getMonth() + 1);
                    this.monthPickers.find('.dp-ext-to').datepicker('setStartDate', date);
                    this.monthPickers.find('.dp-ext-to').datepicker('update', oldDate);
                    
                    if (this.view.get('dateTo') === '')
                    {
                        this.monthPickers.find('.dp-ext-to').find('span').removeClass('active');
                    }
                    else
                    {
                    	var res = this.view.get('dateTo').split(".");
                    	var date_to = new Date();
                    	date_to.setMonth(res[0]);
                    	date_to.setYear(res[1]);
                    	if(this.view.get('dateTo') === this.view.get('dateFrom') || date_to < date)
                		{
                    		this.view.set('dateTo', (date.getMonth() + 1) + '.' + date.getFullYear());
                		}
            		}
                    
                    this.refreshReplaceButton();
                }, this));
            
            this.monthPickers.find('.dp-ext-to')
                .datepicker(this.datepickerDefaults.month)
                .on('changeMonth changeYear', $.proxy(function(e)
                {
                    var date = new Date(e.date);
                    
                    this.view.set('dateTo', (date.getMonth() + 1) + '.' + date.getFullYear());
                    this.refreshReplaceButton();
                    
                    this.monthPickers.find('.dp-ext-to').datepicker('setDate', date);
                }, this));
            
            this.calendarWeekPickers.find('.dp-ext-from')
                .datepicker(this.datepickerDefaults.calendarWeek)
                .on('changeMonth changeYear', $.proxy(function(e)
                {
                    this.calendarWeekPickers.find('.dp-ext-from').datepicker('setDate', e.date);
                }, this));
                
            this.calendarWeekPickers.find('.dp-ext-to')
                .datepicker(this.datepickerDefaults.calendarWeek)
                .on('changeMonth changeYear', $.proxy(function(e)
                {
                    this.calendarWeekPickers.find('.dp-ext-to').datepicker('setDate', e.date);
                }, this));
    
            this.$replaceButton.after(this.$dropdownContainer);
        },

        updateContent: function()
        {
            this.$dropdownContainer.find('.dp-ext-row').removeClass('active');
            var selection = '';

            switch (this.view.get('dateUnit'))
            {
                case this.dateUnits.quarterYear:
                    selection =  '.dp-ext-quarter-year';
                    this.$dropdownContainer.find('.dp-ext-row-quarter-year').addClass('active');
                    break;
                case this.dateUnits.month:
                    selection =  '.dp-ext-month';
                    this.$dropdownContainer.find('.dp-ext-row-month').addClass('active');
                    break;
                case this.dateUnits.calendarWeek:
                    selection =  '.dp-ext-calendar-week';
                    this.$dropdownContainer.find('.dp-ext-row-calendar-week').addClass('active');
                    break;
            }

            this.activeFix();
            this.$dropdownContainer.find(selection).closest('li').addClass('active');
        },

        resetFromTo: function()
        {
            this.view.set('dateFrom', '');
            this.view.set('dateTo', '');
        },
        
        resetActive: function()
        {
        	this.$dropdownContainer.find('.dp-ext-row').removeClass('active');
        	this.$dropdownContainer.find('.dp').removeClass('active');
        	this.$dropdownContainer.find('.dp-row').addClass('hide');
        },

        activeFix: function()
        {
            if (this.view.get('dateFrom') === '' && this.view.get('dateTo') === '')
            {
                this.$dropdownContainer.find('.dp-ext-from').find('tbody').find('td, span, tr')
                    .add(this.$dropdownContainer.find('.dp-ext-to').find('tbody').find('td, span, tr'))
                    .removeClass('active');
            }
        },

        registerEventHandler: function()
        {
            var $this = this;
            
            this.$dropdownContainer.click(function(e)
            {
                e.stopPropagation();
            });
            
            this.$dropdownContainer.find('.dp-ext-quarter-year').click(function(e)
            {
                e.preventDefault();
                $this.resetFromTo();
                $this.$dropdownContainer.find('.dp-row').removeClass('hide');
                $this.$dropdownContainer.find('li').removeClass('active');
                $(this).closest('li').addClass('active');
                $this.view.set('dateUnit', $this.dateUnits.quarterYear);

                $this.updateContent();
                $this.refreshReplaceButton();
            });
            
            this.$dropdownContainer.find('.dp-ext-month').click(function(e)
            {
                e.preventDefault();
                $this.resetFromTo();
                $this.$dropdownContainer.find('.dp-row').removeClass('hide');
                $this.$dropdownContainer.find('li').removeClass('active');
                $(this).closest('li').addClass('active');
                $this.view.set('dateUnit', $this.dateUnits.month);
                
                $this.updateContent();
                $this.refreshReplaceButton();
            });
            
            this.$dropdownContainer.find('.dp-ext-calendar-week').click(function(e)
            {
                e.preventDefault();
                $this.resetFromTo();
                $this.$dropdownContainer.find('.dp-row').removeClass('hide');
                $this.$dropdownContainer.find('li').removeClass('active');
                $(this).closest('li').addClass('active');
                $this.view.set('dateUnit', $this.dateUnits.calendarWeek);
                
                $this.updateContent();
                $this.refreshReplaceButton();
            });
            
            this.$dropdownContainer.find('.dp-ext-reset').click(function(e)
            {
                e.preventDefault();
                
                $this.resetFromTo();
                $this.view.set('dateUnit', '');
                $this.updateContent();
                $this.refreshReplaceButton();
                $this.resetActive();
            });
            
            this.$dropdownContainer.find('.dp-ext-row-calendar-week').find('div.datepicker-days').on('click', 'tbody tr', function()
            {
                var calendarWeek = parseInt($(this).closest('tr').find('td.cw').text(), 10);
                var calendarWeekPrev = parseInt($(this).closest('tr').prev('tr').find('td.cw').text(), 10);
                var calendarWeekNext = parseInt($(this).closest('tr').next('tr').find('td.cw').text(), 10);
                var year = parseInt($(this).closest('table').find('thead').find('.datepicker-switch').text().slice(-4), 10);
                
                if (isNaN(calendarWeekPrev) && calendarWeek > calendarWeekNext)
                {
                    year--;
                }
                else if (isNaN(calendarWeekNext) && calendarWeek < calendarWeekPrev)
                {
                    year++;
                }

                $(this).closest('tbody').find('tr').removeClass('active');
                $(this).closest('tr').addClass('active');

                if ($(this).closest('.datepicker-inline').parent().hasClass('dp-ext-from'))
                {
                    $this.view.set('dateFrom', calendarWeek + '.' + year);
                }
                else
                {
                    $this.view.set('dateTo', calendarWeek + '.' + year);
                }
                
                $this.refreshReplaceButton();
            });
        }
    };
    
    $.fn.datepickerExt = function(option, parameter)
    {
        return this.each(function()
        {
            var data = $(this).data('datepickerExt');
            var options = typeof option === 'object' && option;

            if (!data)
            {
                $(this).data('datepickerExt', (data = new DatepickerExt(this, options)));
            }

            if (typeof option === 'string')
            {
                data[option](parameter);
            }
        });
    };

    $.fn.datepickerExt.Constructor = DatepickerExt;
}
(window.jQuery);